import { COLORS } from '@btime/constants'
import React from 'react'

import { usePeriodicNonCompliances } from './_load/PeriodicNonCompliancesLoader'
import ColumnChart from '../../../../../packages/kiti-charts/components/charts/ColumnChart'
import LineChart from '../../../../../packages/kiti-charts/components/charts/LineChart'

import { useTranslation } from 'react-i18next'

const Chart = ({ widget }) => {
  const { t } = useTranslation('common')
  const data = usePeriodicNonCompliances().reduce((acc, item) => {
    return [
      ...acc,
      { ...item, type: t('widgets.evaluatedCompliances'), value: item.totalCount },
      { ...item, type: t('widgets.nonCompliances'), value: item.nonCompliancesCount }
    ]
  }, [])

  let Component = LineChart
  switch (widget.data?.presentation) {
    case 'column':
      Component = ColumnChart
      break
  }

  const config = {
    data,
    xField: 'date',
    yField: 'value',
    seriesField: 'type',
    colorField: 'type',
    color: [COLORS.dark5, COLORS.red]
  }
  return <Component {...config} />
}

export default Chart
